module.exports = __webpack_public_path__ + "img/arrow-right-s-line.9661788d.svg";